<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
  <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
    <mat-card-title>
      <div class="w-100 d-flex" style="background: #0f172a;">
        <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">A propos</span>
        <button class="m-l-auto" mat-icon-button (click)="matDialogRef.close();">
          <i-tabler name="x" class="icon-18" style="color: #1bb3e6;"></i-tabler>
        </button>
      </div>
    </mat-card-title>
    <mat-card-subtitle style="background: #dee8ff;color: black;" class="p-t-16 p-b-16">
      <div class="d-flex">
        <div class="d-flex flex w-100">
          <div style="border-right: 2px solid #1855d5; margin-right: 15px;">
            <button mat-icon-button>
              <i-tabler name="building-arch" class="icon-24 d-flex" style="color: #1cc8ff; align-items: center;"></i-tabler>
            </button>
          </div>
          <div class="d-grid" style="flex: 1">
            <span class="f-w-700">{{ "CaurisLinkUp" | translate }} - v{{ authSessionDto.APP_VERSION }}</span>
            <span style="padding-top: 8px; font-size: 13px; color: #9b9b9f; font-weight: 600;"> v{{ authSessionDto.APP_VERSION }}</span>
          </div>
        </div>
        <div class="m-l-auto">
        </div>
      </div>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content style="flex: 1;padding: 0;overflow-y: auto;">
    <div style="display: flex; padding: 20px;background: #e5e7ed;">
      <img src="assets/images/logos/clu-logo.png" alt="logo" style="width: 100px; margin: auto;">
      <img src="assets/images/logos/nf-logo.png" alt="logo" style="width: 100px; margin: auto;">
    </div>
    <mat-list>
      <mat-list-item style="height: 40px;">
        <span matListItemIcon><i-tabler name="folder" class="icon-24 d-flex" style="color: black; align-items: center;"></i-tabler></span>
        <span matListItemTitle class="f-w-600 f-s-12">
          <span style="color: #80828d;font-size: 13px;">{{ "Nom du Logiciel" | translate }} : </span>
          <span style="position: absolute; right: 0; margin-right: 10px;">Cauris LinkUp</span>
        </span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item style="height: 40px;">
        <span matListItemIcon><i-tabler name="folder" class="icon-24 d-flex" style="color: black; align-items: center;"></i-tabler></span>
        <span matListItemTitle class="f-w-600 f-s-12">
          <span style="color: #80828d;font-size: 13px;">{{ "Version du logiciel" | translate }} : </span>
          <span style="position: absolute; right: 0; margin-right: 10px;">v{{ authSessionDto.APP_VERSION }}</span>
        </span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item style="height: 40px;">
        <span matListItemIcon><i-tabler name="folder" class="icon-24 d-flex" style="color: black; align-items: center;"></i-tabler></span>
        <span matListItemTitle class="f-w-600 f-s-12">
          <span style="color: #80828d;font-size: 13px;">{{ "Numéro de certification NF525" | translate }} : </span>
          <span style="position: absolute; right: 0; margin-right: 10px;">525/0608-1</span>
        </span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item style="height: 40px;">
        <span matListItemIcon><i-tabler name="folder" class="icon-24 d-flex" style="color: black; align-items: center;"></i-tabler></span>
        <span matListItemTitle class="f-w-600 f-s-12">
          <span style="color: #80828d;font-size: 13px;">{{ "Date certification NF525" | translate }} : </span>
          <span style="position: absolute; right: 0; margin-right: 10px;">17/12/2024</span>
        </span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item style="height: 40px;">
        <span matListItemIcon><i-tabler name="folder" class="icon-24 d-flex" style="color: black; align-items: center;"></i-tabler></span>
        <span matListItemTitle class="f-w-600 f-s-12">
          <span style="color: #80828d;font-size: 13px;">{{ "Catégorie NF" | translate }} : </span>
          <span style="position: absolute; right: 0; margin-right: 10px;">B</span>
        </span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item style="height: 40px;">
        <span matListItemIcon><i-tabler name="folder" class="icon-24 d-flex" style="color: black; align-items: center;"></i-tabler></span>
        <span matListItemTitle class="f-w-600 f-s-12">
          <span style="color: #80828d;font-size: 13px;">{{ "Organisme de certification" | translate }} : </span>
          <span style="position: absolute; right: 0; margin-right: 10px;">INFOCERT </span>
        </span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item style="height: 40px;">
        <span matListItemIcon><i-tabler name="folder" class="icon-24 d-flex" style="color: black; align-items: center;"></i-tabler></span>
        <span matListItemTitle class="f-w-600 f-s-12">
          <span style="color: #80828d;font-size: 13px;">{{ "Éditeur" | translate }} : </span>
          <span style="position: absolute; right: 0; margin-right: 10px;">EDITIONS CAURIS FZCO</span>
        </span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item style="height: 40px;">
        <span matListItemIcon><i-tabler name="folder" class="icon-24 d-flex" style="color: black; align-items: center;"></i-tabler></span>
        <span matListItemTitle class="f-w-600 f-s-12">
          <span style="color: #80828d;font-size: 13px;">{{ "Contact" | translate }} : </span>
          <span style="position: absolute; right: 0; margin-right: 10px;">support@leseditionscauris.com</span>
        </span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item style="height: 40px;">
        <span matListItemIcon><i-tabler name="folder" class="icon-24 d-flex" style="color: black; align-items: center;"></i-tabler></span>
        <span matListItemTitle class="f-w-600 f-s-12">
          <span style="color: #80828d;font-size: 13px;">{{ "Licence valide jusqu'au" | translate }} : </span>
          <span style="position: absolute; right: 0; margin-right: 10px;">{{ authSessionDto.LICENCE_DATE_EXPIRATION | date : 'dd/MM/yyyy' }}</span>
        </span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <ng-container *ngIf="!authSessionDto.NF525">
        <mat-list-item style="height: 40px;">
          <span matListItemIcon><i-tabler name="folder" class="icon-24 d-flex" style="color: black; align-items: center;"></i-tabler></span>
          <span matListItemTitle class="f-w-600 f-s-12">
            <span style="color: #80828d;font-size: 13px;">{{ "NF525" | translate }}</span>
            <span style="position: absolute; right: 0; margin-right: 10px;color: red;font-weight: 700;">{{ "Non appliquée" | translate }}</span>
          </span>
        </mat-list-item>
        <mat-divider></mat-divider>
      </ng-container>
      <mat-list-item style="height: 40px;background:#004c7a;">
        <span matListItemIcon><i-tabler name="download" class="icon-24 d-flex" style="color: white; align-items: center;"></i-tabler></span>
        <span matListItemTitle class="f-w-600 f-s-12">
          <span style="color: white;font-size: 13px;">{{ "Certificat NF525" | translate }} <span style="font-size: 11px; color: #96cbe5; font-weight: 800;">[04/02/25 - 04/02/26]</span></span>
          <span style="position: absolute; right: 0; margin-right: 10px;color: red;font-weight: 700;"><a style="color: #1bbaee;" href="https://certificates.infocert.org/ouvrir_certificat.php?id_elmt=3823&fichier=CERTIF_5250608-1_EDITIONS_CAURIS_FZCO_Cauris_LinkUp.pdf&HR=11:12:53">Lien INFORCERT</a></span>
        </span>
      </mat-list-item>
      <mat-divider></mat-divider> 
    </mat-list>
  </mat-card-content>
  <mat-card-actions class="d-block m-0 p-0" style="background-color: #ffffff; border-top: 3px solid #5d87ff;">
    <div class="d-flex w-100" style="padding-top: 6px;">
      <button mat-stroked-button style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1;" (click)="matDialogRef.close();">
        {{ "FERMER" | translate }}
      </button>
    </div>
  </mat-card-actions>
</mat-card>